var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"prize-competition-registration-feedback"},[_c(_setup.VueFeedback,{attrs:{"type":"error"}},[_c('template',{slot:"feedback-title"},[_vm._v("Hiba történt a regisztráció során. Kérjük próbáld meg újra!")])],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }